module.exports = __webpack_public_path__ + "img/4.9c2c2ba.jpg";